import * as React from 'react';
import { useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import 'tippy.js/dist/tippy.css';

import Bs4Criteria from './Bs4Criteria'
import Bs4CriteriaSummary from './Bs4CriteriaSummary'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportTypeCalendar from './Bs4ReportTypeCalendar';

import {   
  TYPE_NAVIGATION,
  TYPE_SCHEDULER,
  TYPE_MODIFIER,

  VIEW_TYPE_YEAR_MULTI_MOUNTH,
  VIEW_TYPE_YEAR,
  VIEW_TYPE_MONTH,
  VIEW_TYPE_WEEK,
  VIEW_TYPE_DAY,

  VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH,

  footerButtons,
} from './Bs4ReportCalendar/Bs4ReportCalendarConst';

import Bs4ReportTimeline from './Bs4ReportCalendar/Bs4ReportTimeline';

import Bs4I18N from '../Bs4I18N';

import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import { getBoxSx, UxAccordion, useStateUxTemplate } from '../Bs4Theme/Bs4UxTemplates';
import { HideOnScroll, useScrollTarget} from '../Bs4Components/HideOnScroll';

const TYPE_BS4REPORT = 'type_Bs4Report35';
const NAME_BS4REPORT = 'Bs4Report35';

const ATRYBUT_SCHED_SHOWEXACT ='schedexact';
const ATRYBUT_SCHED_SHOWFIXED = 'schedfixed';
const ATRYBUT_SCHED_SHOWYEAR ='schedyear';
const ATRYBUT_SCHED_SHOWMONTH = 'schedmonth';
const ATRYBUT_SCHED_SHOWWEEK = 'schedweek';
const ATRYBUT_SCHED_SHOWDAY = 'schedday';

//Terminarz New
export default class Bs4ReportType35 extends Bs4ReportTypeCalendar {    

  createModel() {    
    super.createModel();
    this.initialValues = {};
    this.initialValues.bs4rowheight = this.getPageParam('bs4rowheight') || null;
    this.initialValues.leftColumnWidth = this.getPageParam('leftColumnWidth') || 150;     
    this.initialValues.bs4axisName = this.getPageParam('bs4axisName')
    this.initialValues.allowaddevent = this.getPageParam('allowaddevent')
    this.initialValues.minInterval =  parseInt(this.getPageParam('min_interval')) || 5;
    this.initialValues.bs4FormField = this.props.bs4FormField;
    this.initialValues.formId = this.props.formId;    
    
    this.viewButtons = {};

    const schedexact = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWEXACT));
    const schedfixed = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWFIXED));

    this.initialValues.adjustmentToUnitWidth = schedfixed;

    this.viewButtons[VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH] = schedfixed === schedexact;
    this.viewButtons[VIEW_TYPE_YEAR] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWYEAR));
    this.viewButtons[VIEW_TYPE_MONTH] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWMONTH));
    this.viewButtons[VIEW_TYPE_WEEK] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWWEEK));
    this.viewButtons[VIEW_TYPE_DAY] = Boolean(this.getPageParam(ATRYBUT_SCHED_SHOWDAY));

    const bs4schscope = this.getPageParam('bs4schscope');    
    try {
      const bs4schscopeJson = JSON.parse(bs4schscope);
      this.initialValues.viewType = bs4schscopeJson.DateScope;
      if (bs4schscopeJson.hasOwnProperty('adjustmentToUnitWidth') && this.viewButtons[VIEW_TYPE_MODIFIER_ADJUSTMENT_TO_UNIT_WIDTH]) {
        this.initialValues.adjustmentToUnitWidth = Boolean(parseInt(bs4schscopeJson.adjustmentToUnitWidth) === 1);  
      }
    } catch(error) {
      this.initialValues.viewType = bs4schscope;
    }

    this.bs4ReportTimeline = new Bs4ReportTimeline(this.initialValues);
    this.bs4ReportTimeline.bs4KartotekaId = this.bs4KartotekaId;
    this.reloadAll = () => {
      this.bs4ReportTimeline.reload()
    }
  }

  defaultUxTemplate = {
    class: 189,
    name: NAME_BS4REPORT,
    body: {
      Report35: {          
        event: {
          // margin: 1,
          // padding: 1,
          // elevation: 2,
          // borderRadius: 2,
        },
        footer: {
          [TYPE_SCHEDULER]: footerButtons.filter(item => item.type === TYPE_SCHEDULER).map(item => item.id),
          // [TYPE_NAVIGATION]: this.footerNavigation.filter(item => item.type === TYPE_NAVIGATION).map(item => item.id),
          [TYPE_NAVIGATION]: [0],
          [TYPE_MODIFIER]: footerButtons.filter(item => item.type === TYPE_MODIFIER).map(item => item.id),
        },
        options: {
          margin: 0,
          padding: 1,
          elevation: 2,
          borderRadius: 2,
          minWidth: 200,
        },
      }        
    }
  };

  isSelected = (footer, view, type) => {
    if (view.type !== type) return false;    
    if (!Array.isArray(footer?.[type])) return false;
    return footer?.[type]?.includes(view.id)
  }

  getSelectedIdArray() {
    console.log('== Error === Bs4GenericReport == getSelectedIdArray - not implemented')
    return []
  }

  getUxTemplateEditor = (uxEditor) => {    
    const report = this;
    const type = TYPE_BS4REPORT;
    const eds = [{
      label: Bs4I18N.getTT('Zdarzenie', 'Event', NAME_BS4REPORT),
      types: [TYPE_BS4REPORT],
      onReset: () => this.uxTemplate.body.Report35.event = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report35.event)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Report35;
        
        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.event} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.event} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.event} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.event} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.event} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.event} name='borderWidth'/>

            {/* <uxEditor.ViewCssText types={type} value={uxBody.event} name='minWidth'/> */}
            <uxEditor.ViewCssText types={type} value={uxBody.event} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.event} name='padding'/>
          </Box>
        );
      },
    },

    // {
    //   label: Bs4I18N.getTT('Footer', 'Footer', 'Bs4ReportType35'),      
    //   types: [TYPE_BS4REPORT35],
    //   onReset: () => this.uxTemplate.body.Report35.footer = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report35.footer)),
    //   Content: (props) => {
    //     const uxBody = this.uxTemplate.body.Report35;
    //     const {} = useStateUxTemplate(type);

    //     return (
    //       <Box display='flex' flexDirection='column' p={1.5}>
    //         <uxEditor.ViewCssCheckboxes 
    //           types={type}
    //           value={uxBody.footer} 
    //           options={footerButtons.filter(view => view.type === TYPE_SCHEDULER)}   
    //           name={TYPE_SCHEDULER} 
    //           title='Terminarz'
    //         />
    //         <uxEditor.ViewCssCheckboxes 
    //           types={type}
    //           value={uxBody.footer} 
    //           options={[{id: 0, name: '<<...>>'}]}
    //           name={TYPE_NAVIGATION} 
    //           title='Nawigacja'
    //         />
    //         <uxEditor.ViewCssCheckboxes
    //           types={type}
    //           value={uxBody.footer}
    //           options={footerButtons.filter(view => view.type === TYPE_MODIFIER)}
    //           name={TYPE_MODIFIER}
    //           title='Modyfikacje'
    //         />
    //       </Box>
    //     );
    //   },
    // },

    {
      label: Bs4I18N.getTT('Menu options', 'Opcje menu', NAME_BS4REPORT),
      types: [TYPE_BS4REPORT],
      onReset: () => this.uxTemplate.body.Report35.options = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report35.options)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Report35;
        
        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.options} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.options} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.options} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.options} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.options} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.options} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.options} name='minWidth'/>
            <uxEditor.ViewCssText types={type} value={uxBody.options} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.options} name='padding'/>
          </Box>
        );
      },
    }];
    
    return [{
      label: Bs4I18N.getTT('Report35', 'Report35', NAME_BS4REPORT),
      getUxTemplate: () => this.uxTemplate,
      setUxTemplate: this.setUxTemplate,
      types: [TYPE_BS4REPORT],
      Content: (props) => {
        const [expanded, setExpanded] = React.useState(eds[0].label);
        
        const handleChange = (panel) => (event, isExpanded) => {
          // console.log('... UxAccordion .Main. .handleChange.', panel, isExpanded)
          setExpanded(isExpanded ? panel : false);
        };
  
        // console.log('... UxAccordion .Main.', props)

        return (
          <React.Fragment>
            {eds.map((ux, index) => {
              return (
                <UxAccordion
                  key={index} 
                  label={ux.label} 
                  types={ux.types}
                  expanded={expanded} 
                  onChange={handleChange} 
                  onReset={ux.onReset}
                >
                  <ux.Content />
                </UxAccordion>
              )
            })}
          </React.Fragment>
        )
      },
    }]    
  }

  fetchCriteriaVals = (bs4Timeline) => {
    const filterCriteria = this.defaultCriteriaVals();
    filterCriteria.startDateIso = Bs4Utils.toDate(bs4Timeline.start);
    filterCriteria.endDateIso = Bs4Utils.toDate(bs4Timeline.end);
    filterCriteria.DateScope = bs4Timeline.viewType;
    filterCriteria.adjustmentToUnitWidth = bs4Timeline.adjustmentToUnitWidth ? '1' : '0';
    if (this.remembersettings) {
      filterCriteria.remembersettings = 1;    
      filterCriteria.newGridDesign = this.packColumnLayout();	// zapamietany uklad kolumn
    }
    return filterCriteria;
  }
    
  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORT);
    const setScrollTarget = useScrollTarget(this.optionId, props.formField);
    const [uxBodyEvent, uxBodyFooter, uxBodyOption] = React.useMemo(() => {
      return [{...this.uxTemplate.body.Report35.event}, {...this.uxTemplate.body.Report35.footer}, {...this.uxTemplate.body.Report35.options}];
    }, [dateTimeStamp]);

    // console.log('...TYPE_BS4REPORT35...', );
    
    return (
      <Box 
        ref={ref} 
        //height='100%' 
        width='100%' 
        display='flex' 
        flexDirection="column"
        px={props.uxKartoteka?.spacing}
      >        
        <HideOnScroll debug='Type35-1-' type={report.optionId}>
          <Box>
          <report.ReportBs4HorizontalMenu 
            bs4Menu={report.menuItems}
            onMenuClick={report.handleMenuClick} 
          />
          <Box display="flex" flexDirection="row" flexWrap='wrap' gap='6px' p={0.5} alignItems='center'>
            <Bs4Criteria {...report.props}/>
          </Box>
          </Box>
        </HideOnScroll>
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <Bs4CriteriaSummary {...report.props}/>
        <report.bs4ReportTimeline.ViewComponent
          columnsMenu={report.columnsMenu} 
          uxBodyEvent={uxBodyEvent}
          uxBodyFooter={uxBodyFooter}
          uxBodyOption={uxBodyOption}
          onMenuClick={report.handleMenuClickEvent}
          fetchMore={report.fetchMore}
          onShow={report.handleReportIconShow}
          onRemember={report.handleReportIconRemember}
          onReset={report.handleReportIconReset}
          viewButtons={report.viewButtons}
          onRowClick={report.handleRowClick}
          setScrollTarget={setScrollTarget}
        />
      </Box>
    )
  });
}
